import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'any',
})
export class RequestcallapiService {
  private scriptName = 'DEV\\CallBack%20Button%20Now_DEV';
  private busNo = '4595643';
  private scriptId = environment.scriptId;
  private skillNo = environment.skillNo;
  private baseUrl =
    `https://home-c15.incontact.com/inContact/Manage/Scripts/Spawn.aspx?scriptName=${this.scriptName}&bus_no=${this.busNo}&scriptId=${this.scriptId}&skill_no=${this.skillNo}`;

  constructor(private http: HttpClient) {}

  postData(data: any): Observable<any> {
    const params = {
      p1: data.firstName,
      p2: data.lastName,
      p3: data.phoneNumber,
      p4: data.accountNumber,
      p5: '',
      p6: '',
      p7: '',
      p8: data.reason,
      p9: data.language,
      Guid: 'cf6aa737-4b38-45e0-8f9e-844493b3e1c9',
    };

    const url = `${this.baseUrl}&${new URLSearchParams(params).toString()}`;
    return this.http.get<any>(url); // Use GET since the request URL suggests it
  }
}
